var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { HelperService } from "app/lib/helper.service";
import { BaseComponent } from "app/views/base.component";
import { EventsService } from "app/lib/EventsService";
import { ModalService } from "app/views/modal/base_modal.component";
import { ChartParams } from "../../views/chart/chart.component";
import { UserService } from "../user.service";
var UserChartsComponent = /** @class */ (function (_super) {
    __extends(UserChartsComponent, _super);
    function UserChartsComponent(document, eventsService, helper, activatedRoute, translate, router, modalService, filter, userService) {
        var _this = _super.call(this, eventsService, userService, activatedRoute, filter, translate) || this;
        _this.document = document;
        _this.eventsService = eventsService;
        _this.helper = helper;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.userService = userService;
        _this.addFilterParams = {
            dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated'],
            isRegDay: true,
            userType: 'user'
        };
        _this.mailChart = new ChartParams();
        _this.regChart = new ChartParams();
        _this.browserChart = new ChartParams();
        _this.activityChart = new ChartParams();
        _this.mailChart.setOptions({
            title: _this.translate.__A('users.reg_day.Mail domain'),
            type: 'pie'
        });
        _this.regChart.setOptions({
            title: _this.translate.__A('filterForm.regFilter'),
            type: 'pie'
        });
        _this.browserChart.setOptions({
            title: _this.translate.__A('users.reg_day.browsers'),
            type: 'pie'
        });
        _this.activityChart.setOptions({
            title: _this.translate.__A('users.reg_day.activity'),
        });
        return _this;
    }
    UserChartsComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMailChart()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getRegChart()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getBrowserChart()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.getActivityChart()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserChartsComponent.prototype.getMailChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.mailChart.showLoader();
                        return [4 /*yield*/, this.userService.userCharts.chart(this.filter.filterParams, 'mails').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.mailChart.data = charts;
                        this.mailChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserChartsComponent.prototype.getRegChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.regChart.showLoader();
                        return [4 /*yield*/, this.userService.userCharts.chart(this.filter.filterParams, 'reg').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.regChart.data = charts;
                        this.regChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserChartsComponent.prototype.getBrowserChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.browserChart.showLoader();
                        return [4 /*yield*/, this.userService.userCharts.chart(this.filter.filterParams, 'browser').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.browserChart.data = charts;
                        this.browserChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    UserChartsComponent.prototype.getActivityChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.activityChart.showLoader();
                        return [4 /*yield*/, this.userService.userCharts.chart(this.filter.filterParams, 'activity').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.activityChart.data = charts;
                        this.activityChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    return UserChartsComponent;
}(BaseComponent));
export { UserChartsComponent };
